import Cookies from 'js-cookie';
import { IncomingMessage } from 'http';
import {
  SMART_CHAT_BETA_COOKIE_NAME,
  SMART_CHAT_OPT_IN_DAYS,
  SMART_CHAT_OPT_OUT_DAYS,
  USE_AI_CHAT_COOKIE_NAME,
} from 'constants/cookies';
import { getStringFromRequestCookie } from './request-cookies';

export enum SmartChatBetaStatus {
  OPTED_IN = 'opted_in',
  OPTED_OUT = 'opted_out',
  UNDECIDED = 'undecided'
}

/**
 * Sets the SmartChat beta cookie to opted-in (1 year expiry).
 * Also sets use-ai-chat to 'true' after opt-in
 */
export function setSmartChatOptIn(): void {
  Cookies.set(SMART_CHAT_BETA_COOKIE_NAME, 'true', {
    expires: SMART_CHAT_OPT_IN_DAYS,
    path: '/',
  });
  // Default to AI Search view after opt-in
  Cookies.set(USE_AI_CHAT_COOKIE_NAME, 'true', {
    expires: SMART_CHAT_OPT_IN_DAYS,
    path: '/',
  });
}

/**
 * Sets the SmartChat beta cookie to opted-out
 * Removes the use-ai-chat cookie.
 */
export function setSmartChatOptOut(): void {
  Cookies.set(SMART_CHAT_BETA_COOKIE_NAME, 'false', {
    expires: SMART_CHAT_OPT_OUT_DAYS,
    path: '/',
  });
  // Remove use ai chat cookie
  Cookies.remove(USE_AI_CHAT_COOKIE_NAME, { path: '/' });
}

/**
 * Gets the SmartChat Beta status
 */
export function getSmartChatBetaStatus(req?: Pick<IncomingMessage, 'headers'>): SmartChatBetaStatus {
  // Server-side: read from request headers
  if (req) {
    const betaCookieValue = getStringFromRequestCookie(SMART_CHAT_BETA_COOKIE_NAME, req);
    if (betaCookieValue === 'true') return SmartChatBetaStatus.OPTED_IN;
    if (betaCookieValue === 'false') return SmartChatBetaStatus.OPTED_OUT;
    return SmartChatBetaStatus.UNDECIDED;
  }
  
  // Client-side: read from browser cookies
  const betaCookieValue = Cookies.get(SMART_CHAT_BETA_COOKIE_NAME);
  if (betaCookieValue === 'true') return SmartChatBetaStatus.OPTED_IN;
  if (betaCookieValue === 'false') return SmartChatBetaStatus.OPTED_OUT;
  return SmartChatBetaStatus.UNDECIDED;
}
